import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const customizeCanvas = ({ img, title }) => {
    const padding = 50;
    const titleHeight = 30;
    const titleMarginTop = 20;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = img.width + padding * 2;
    canvas.height = img.height + padding * 2 + titleHeight + titleMarginTop;

    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = 'black';
    ctx.font = '40px Montserrat, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(title, canvas.width / 2, padding + titleMarginTop);

    ctx.drawImage(img, padding, padding + titleHeight + titleMarginTop);

    return canvas;
};

const downloadSnapshotWithTitle = ({ id, base64Image, title }) => {
    const img = new Image();
    img.src = base64Image;
    img.onload = () => {
        const canvas = customizeCanvas({ img, title });

        const link = document.createElement('a');
        if (!canvas?.toDataURL) return;
        link.href = canvas.toDataURL('image/png');
        const newTitleName = title.replace(/ /g, '_');
        const fileName = `${id}_${newTitleName}`;
        link.download = `${fileName}.png`;
        link.click();
    };
};

export const downloadSnapshot = ({ id, title, image, withTitle }) => {
    if (!id || !image) return;
    if (title && withTitle) {
        downloadSnapshotWithTitle({ id, base64Image: image, title });
        return;
    }
    const a = document.createElement('a');
    a.href = image;
    let fileName = `${id}`;
    if (title) {
        const newTitle = title.replace(/ /g, '_');
        fileName = `${fileName}_${newTitle}`;
    }
    a.download = `${fileName}.jpeg`;
    a.click();
};

const addTitleToImage = ({ folder, id, image, title, type }) => {
    if (!id || !image || !folder) return Promise.resolve();

    return new Promise((resolve, reject) => {
        let fileName = `${id}`;

        if (title) {
            const newTitle = title.replace(/ /g, '_');
            fileName = `${fileName}_${newTitle}`;
        }

        fileName = `${fileName}.${type || 'jpg'}`;

        const img = new Image();
        img.src = image;

        img.onload = () => {
            const canvas = customizeCanvas({ img, title });
            if (!canvas) return reject();
            const newImage = canvas.toDataURL('image/png');
            const base64Content = newImage.split(',')[1];

            folder.file(fileName, base64Content, { base64: true });
            resolve();
        };

        img.onerror = (error) => {
            console.error('Error loading the image:', error);
            reject(error);
        };
    });
};

export const downloadMultipleSnapshots = ({ snapshots = {} }) => {
    if (!Object.keys(snapshots).length) return Promise.reject();

    return new Promise((resolve, reject) => {
        Object.entries(snapshots).forEach(([id, { title, image, type }]) => {
            downloadSnapshot({ id, title, image, withTitle: true });
        });
        resolve();
    });
};

export const downloadMultipleSnapshotsAsZip = ({
    snapshots = {},
    withTitle,
    dashboardName,
    fileName,
    t,
}) => {
    if (!Object.keys(snapshots).length) return Promise.reject();

    const zip = new JSZip();
    const folder = zip.folder(dashboardName || t('label_charts'));

    const promises = [];

    Object.entries(snapshots).forEach(([id, { title, image, type }]) => {
        if (id && image && folder) {
            if (withTitle) {
                promises.push(addTitleToImage({ folder, id, image, title, type }));
            } else {
                const promise = new Promise((resolve, reject) => {
                    let fileName = `${id}`;

                    if (title) {
                        const newTitle = title.replace(' ', '_');
                        fileName = `${fileName}_${newTitle}`;
                    }

                    fileName = `${fileName}.${type || 'png'}`;

                    const base64Content = image.split(',')[1];
                    folder.file(fileName, base64Content, { base64: true });
                    resolve();
                });
                promises.push(promise);
            }
        }
    });

    return Promise.all(promises).then(() => {
        return zip
            .generateAsync({ type: 'blob' })
            .then((content) => {
                let zipName = `${t('title_charts').toLowerCase()}.zip`;
                if (fileName) zipName = `${fileName.toLowerCase()}.zip`;
                saveAs(content, zipName);
            })
            .catch((err) => {
                console.error('Error generating zip:', err);
            });
    });
};
